const DEFAULT_SALT_LENGTH = 16
const DEFAULT_ITERATIONS = 1000

export function generateSalt(length: number = DEFAULT_SALT_LENGTH): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+-=[]{}|;:,.<>?'
  let salt = ''
  const array = new Uint32Array(length)
  crypto.getRandomValues(array)

  for (let i = 0; i < length; i++) {
    salt += chars[array[i] % chars.length]
  }
  return salt
}

export async function hashWithSalt(
  data: string,
  salt: string,
  iterations: number = DEFAULT_ITERATIONS
): Promise<string> {
  const encoder = new TextEncoder()
  let dataBuffer = encoder.encode(data + salt)

  for (let i = 0; i < iterations; i++) {
    const hashBuffer = await crypto.subtle.digest('SHA-256', dataBuffer)
    dataBuffer = new Uint8Array(hashBuffer)
  }

  const hashArray = Array.from(new Uint8Array(dataBuffer))
  return hashArray.map((b) => b.toString(16).padStart(2, '0')).join('')
}

export function generateSaltSync(length: number = DEFAULT_SALT_LENGTH): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+-=[]{}|;:,.<>?'
  let salt = ''
  for (let i = 0; i < length; i++) {
    salt += chars[Math.floor(Math.random() * chars.length)]
  }
  return salt
}

export function simpleHash(str: string): string {
  let hash = 0
  if (str.length === 0) return hash.toString()

  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i)
    hash = (hash << 5) - hash + char
    hash = hash & hash
  }

  return hash.toString(16)
}

export function md5Hash(str: string): string {
  const convertToWordArray = (input: string) => {
    const msg = unescape(encodeURIComponent(input))
    const words: number[] = []
    for (let i = 0; i < msg.length; i++) {
      words[i >> 2] |= msg.charCodeAt(i) << (8 * (i % 4))
    }
    return words
  }

  const words = convertToWordArray(str)

  const a = 0x67452301
  const b = 0xefcdab89
  const c = 0x98badcfe
  const d = 0x10325476

  void words

  const result = [a, b, c, d]
  const hashArray = new Uint8Array(new Uint32Array(result).buffer)

  return Array.from(hashArray)
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('')
}

export function createSignature(params: Record<string, any>, secret: string): string {
  const sortedKeys = Object.keys(params).sort()
  const signStr = sortedKeys.map((key) => `${key}=${params[key]}`).join('&') + `&secret=${secret}`
  return simpleHash(signStr)
}
